import { combineReducers } from 'redux';

// Confirmation
import { confirmationReducer } from '../../Confirmation/ConfirmationReducers';
import { IConfirmationState } from '../../Confirmation/ConfirmationModel';

// Notification
import { notifications } from '../../Notifications/NotificationReducer';
import { INotificationState } from '../../Notifications/notificationModel';

// Dashboard
import { dashboard } from '../../Dashboard/DashboardReducer';
import { IDashboardState } from '../../Dashboard/DashboardModels';

// Root Reducer
const index = combineReducers({
    confirmation: confirmationReducer,
    notifications,
    dashboard,
});

export interface IAppStore {
    confirmation?: IConfirmationState;
    notifications?: INotificationState;
    dashboard?: IDashboardState;
}

export default index;
